import {checkPermission} from '@/utils/permissionsUtil'

export default {
    name: 'audit',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'audit-timeline-index',
            component: () => import(/* webpackChunkName: "audit-timeline" */ '@/modules/audit/views/AuditTimeline.vue'),
            beforeEnter: (to, from, next) => {
                if (!checkPermission('audit-timeline-index')) {
                    return next({name: 'dashboard-index'})
                }
                next()
            }
        }
    ]
}
